import React from 'react'
import styled from '@emotion/styled'
import { keyframes } from '@emotion/react'
import { greenBase, grayLight40 } from '../../constants/principles'

export default () => (
  <StatusBarStyle>
    <Progress />
  </StatusBarStyle>
)

const progressKeyframes = keyframes`
  0% {
    left: -55%;
    
  }
  80% {
    left: 50%;
  }
  95% {
    left: 120%;
  }
  
  100% {
    left: 100%;
  }
`

const StatusBarStyle = styled.div`
  position: relative;
  height: 8px;
  width: 100%;
  background: ${grayLight40};
  overflow: hidden;
  border-radius: 4px;
  top: 5px;
`

const Progress = styled.span`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 40%;
  background-color: ${greenBase};
  animation: ${progressKeyframes} 3s linear infinite;
`
